import React, {useEffect} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiX} = FiIcons;

// Dialog für rechtliche Texte (Esc, Klick außerhalb und Button schließen)
function LegalModal({title, sections, onClose}) {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
        className="max-h-[85vh] w-full max-w-2xl overflow-y-auto rounded-2xl bg-white p-6 text-gray-800 shadow-2xl sm:p-8"
      >
        <div className="flex items-start justify-between gap-4">
          <h2 className="text-2xl font-extrabold text-[#111827]">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Schließen"
            className="rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-[#D52B1E]"
          >
            <SafeIcon icon={FiX} className="text-xl" />
          </button>
        </div>
        {sections.map((s) => (
          <section key={s.heading} className="mt-6">
            <h3 className="font-bold text-[#1E3A8A]">{s.heading}</h3>
            {s.lines.map((l) => (
              <p key={l} className="mt-1 text-sm leading-relaxed text-gray-700">{l}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}

export default LegalModal;